module.exports = __webpack_public_path__ + "assets/img/theX-content-7.805085d6.png";